import { render, staticRenderFns } from "./MiniaturesSection.vue?vue&type=template&id=726f9f83&scoped=true"
import script from "./MiniaturesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MiniaturesSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MiniaturesSection.vue?vue&type=style&index=0&id=726f9f83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f9f83",
  null
  
)

export default component.exports